import { generateTableItems } from '@app/pages/ProcessingResultsPageInner/lib'

import { titlesMap, monitoringDataTargetKeys, pricesDataTargetKeys } from './сonfigs'

import type { LabelValueRowData } from '@app/components/LabelValueTable/types'
import type { MonitoringCharacteristics } from '@app/pages/ProcessingResultsPageInner/types'

export const generateMonitoringDataTableItems = (data?: MonitoringCharacteristics): LabelValueRowData[] => {
  return generateTableItems({
    data,
    titlesMap,
    targetKeys: monitoringDataTargetKeys
  })
}

export const generatePricesDataTableItems = (data?: MonitoringCharacteristics): LabelValueRowData[] => {
  return generateTableItems({
    data,
    titlesMap,
    targetKeys: pricesDataTargetKeys
  })
}
